// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"755":"beefbfd0","787":"f72c73a3","962":"d862e6b8"}[chunkId] + ".chunk.js";
};